module.exports = __webpack_public_path__ + "3975f43c43d58bf3374efb86d252b464.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./client/assets/upicons.ttf
 ** module id = 818
 ** module chunks = 0
 **/